(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ProcedureDiagnosisSearch', ProcedureDiagnosisSearch);

    ProcedureDiagnosisSearch.$inject = ['$resource'];

    function ProcedureDiagnosisSearch($resource) {
        var resourceUrl =  'api/_search/procedure-diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
